export default __webpack_public_path__ + "static/media/tolu2.5b122b29.png";